import React from 'react'
import PropTypes from 'prop-types'
import { MobileTopList, TitleContent, TitleIconWrapper } from '../Search.styles'
import { SearchCategory } from 'constants/enums'
import ResultRowMobile from './ResultRowMobile'
import { Tonality } from '@dsny/dsny-component-library'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Help } from '@dsny/dsny-component-library/icons'
function TopResultsMobile({
  results = [],
  useAISearch = false,
  loading,
  renderNoResults,
  onShowModal,
  onPlayRelease,
  onDownloadRelease,
  onPlayTrack,
  onDownloadTrack
}) {
  const theme = useTheme()
  const { t } = useTranslation()
  const aiTooltipText = t('search.ai-results-tooltip')

  const items = results.map(({ item, type }, index) => {
    if (!item) return null

    const key =
      item.trackid ||
      item.releaseid ||
      item.artistid ||
      item.labelid ||
      index + 1

    return (
      <ResultRowMobile
        key={`${type || SearchCategory.releases}-${key}`}
        type={type || SearchCategory.releases}
        item={item}
        onShowModal={onShowModal}
        onPlayRelease={onPlayRelease}
        onDownloadRelease={onDownloadRelease}
        onPlayTrack={onPlayTrack}
        onDownloadTrack={onDownloadTrack}
      />
    )
  })

  const hasResults = items.filter(Boolean).length > 0

  if (!hasResults && !loading) return renderNoResults()
  return (
    <MobileTopList>
      {useAISearch ? (
        <TitleContent style={{ marginBottom: 8 }}>
          <Tonality.UIHeading
            headingStyle="headline5"
            color={theme.colors.neutralW90}
          >
            {t('search.ai-results')}
          </Tonality.UIHeading>
          <Tonality.Tooltip
            mode="dark"
            hhasArrow={false}
            placement="top"
            content={aiTooltipText}
            containerStyles={{ width: 360 }}
            children={
              <button>
                <TitleIconWrapper aria-label={aiTooltipText} role="button">
                  <Help
                    width="18px"
                    height="18px"
                    color={theme.colors.white0}
                  />
                </TitleIconWrapper>
              </button>
            }
          />
        </TitleContent>
      ) : (
        <Tonality.UIHeading
          headingStyle="headline5"
          style={{ marginBottom: 8 }}
          color={theme.colors.neutralW90}
        >
          {t('search.top-results')}
        </Tonality.UIHeading>
      )}

      {items}
    </MobileTopList>
  )
}

TopResultsMobile.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.object,
      type: PropTypes.oneOf([
        SearchCategory.tracks,
        SearchCategory.releases,
        SearchCategory.artists,
        SearchCategory.labels
      ])
    })
  ).isRequired,
  useAISearch: PropTypes.bool,
  loading: PropTypes.bool,
  renderNoResults: PropTypes.func.isRequired,
  onShowModal: PropTypes.func.isRequired,
  onPlayRelease: PropTypes.func.isRequired,
  onDownloadRelease: PropTypes.func.isRequired,
  onPlayTrack: PropTypes.func.isRequired,
  onDownloadTrack: PropTypes.func.isRequired
}

export default TopResultsMobile
